import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";

export const useIsSensorReliabilityEnabled = () => {
    const featureFlags = useFeatureFlags();
    return featureFlags.includes("isSensorReliabilityEnabled");
}